import { Box } from '@mui/material';
import { wGroupIndicesATGenericComponents } from 'components/AgentTemplateEditView/menu/genericComponents';
import WGroup from 'components/general/WGroup';
import SubsystemWizard from './SubsystemWizard';

const GenericComponentsEditBoard = () => {
  return (
    <WGroup index={wGroupIndicesATGenericComponents.GENERIC_COMPONENTS}>
      <Box component="div" display="flex" flexWrap="wrap">
        <SubsystemWizard />
      </Box>
    </WGroup>
  );
};

export default GenericComponentsEditBoard;
